/**
 * 조회조건 세션 유지 — [조회] 때 조회영역 값을 `MenuStorage.menuOnSession.setSearch` + URL 에 남기고, 진입 때 URL 에서
 * 한 번 되살린다(rgr01V2 `searchQuery.ts` 방식). 조회영역은 센터도착일자(ARRIVE_DATE)·반송번호(rgr09Invoice) 둘뿐이다 — 화주 조건 없음.
 * `Utils.qsStringify`(comma·encode:false) → `useParsedQuery`(comma) 왕복이라 반송번호는 하나씩 인코딩해 싣는다.
 */
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/

export type Rgr12SearchQuery = { arriveDateFrom?: string; arriveDateTo?: string; rgr09Invoice?: string[] }

const cleanList = (v: unknown): string[] => {
  if (Array.isArray(v)) return v.filter((x) => typeof x === 'string' || typeof x === 'number').map(String).filter(Boolean)
  return typeof v === 'string' && v.trim() ? [v.trim()] : []
}
const asDate = (v: unknown): string | undefined => (typeof v === 'string' && DATE_RE.test(v) ? v : undefined)

/** 조회영역 값 → 저장 형태. 빈 값은 싣지 않는다 */
export const toSearchQuery = (fl: Record<string, unknown>): Rgr12SearchQuery => {
  const q: Rgr12SearchQuery = {}
  const [from, to] = Array.isArray(fl.ARRIVE_DATE) ? (fl.ARRIVE_DATE as unknown[]) : []
  if (asDate(from) && asDate(to)) Object.assign(q, { arriveDateFrom: from, arriveDateTo: to })
  const invoices = cleanList(fl.rgr09Invoice)
  if (invoices.length) q.rgr09Invoice = invoices.map(encodeURIComponent)
  return q
}

/**
 * URL 쿼리 → 조회영역 값. 센터도착일자가 없으면 복원하지 않는다 — [조회] 는 늘 날짜를 채워 저장하므로 날짜 없는 쿼리는 최초 진입이거나 [초기화] 뒤다.
 */
export const fromSearchQuery = (q: Record<string, unknown>): Record<string, unknown> | undefined => {
  const from = asDate(q.arriveDateFrom)
  const to = asDate(q.arriveDateTo)
  if (!from || !to) return undefined
  const invoices = cleanList(q.rgr09Invoice)
  return { ARRIVE_DATE: [from, to], ...(invoices.length ? { rgr09Invoice: invoices } : {}) }
}
